import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTurma = (): TabelaColuna => ({
  Chave: 'turma',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 250 }}>Turma</div>
})
